<template>
  <div class="title">
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>申请</h3>
        </div>
        <el-row :gutter="20">
          <el-col :span="3">
            <div class="text-center point email" @click="handleEmail" title="电子邮件">
              <el-badge :value="count" :hidden="!count" class="count" />
              <img src="@/assets/img/email.png" alt="" class="mauto" style="width:53px">
              <p class="mt10 ec">电子邮件</p>
            </div>
          </el-col>
          <el-col :span="3" v-for="(item, index) in list" :key="index">
            <div class="text-center point" @click="onStartFlow(item)" :title="item.menuName">
              <img :src="item.img" alt="" class="mauto" style="width:60px">
              <p class="mt10 ec">{{ item.menuName }}</p>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-card class="box-card" style="height: 300px;">
            <div slot="header" class="clearfix">
              <h3>待办工作</h3>
            </div>
            <ul class="auto" style="height: 200px;">
              <li v-for="(item, index) in dataList" :key="index" class="work" style="display: flex;align-items: center"
                @click="onSubmit(item)">
                <img src="@/assets/icon/0.jpg" alt="" width="40" height="40"
                  style="margin-right: 12px">
                <div style="flex:1;">
                  <div style="display: flex;align-items: center;justify-content:space-between">
                    <h4 style="width: 75%" class="ec">{{ item.runName }}</h4>
                    <p class="ec">{{ item.processInstanceStartTime }}</p>
                  </div>
                  <div style="display: flex;align-items: center;justify-content:space-between">
                    <p style="width: 60%" class="ec">发起人：{{ item.runName ? item.runName.split('）')[1] : '' }}</p>
                    <el-tag size="small">处理中</el-tag>
                  </div>
                </div>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card" style="height: 300px">
            <div slot="header" class="clearfix">
              <h3>个人考勤</h3>
            </div>
            <div style="height: 200px">
              <div id="echart-pie" style="height: 100%"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-card class="box-card" style="height: 340px">
            <div slot="header" class="clearfix">
              <h3>公共文件柜</h3>
            </div>
            <div style="height: 200px;overflow-y: auto;overflow-x: hidden">
              <div style="display: flex;justify-content: flex-start;flex-wrap: wrap">
                <div v-for="(item, index) in fileList" :key="index" style="width: 20%;margin-bottom: 17px">
                  <div style="text-align: center" class="point" @click.stop="handleClickImg(item)">
                    <img v-if="item.type == 'FOLDER'" src="@/assets/icon/folder.jpg" mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'jpg' || item.suffix == '.jpg'" src="@/assets/icon/img.png"
                      mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'video' || item.suffix == '.video'"
                      src="@/assets/icon/video.png" mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'doc' || item.suffix == '.doc'"
                      src="@/assets/icon/words.png" mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'xls' || item.suffix == '.xls'"
                      src="@/assets/icon/xlsx.png" mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'pdf' || item.suffix == '.pdf'" src="@/assets/icon/pdf.png"
                      mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'zip' || item.suffix == '.zip'" src="@/assets/icon/zip.png"
                      mode="aspectFit" />
                    <img class="img" v-else-if="item.suffix == 'ppt' || item.suffix == '.ppt'" src="@/assets/icon/ppt.png"
                      mode="aspectFit" />
                    <img v-else src="@/assets/icon/folder.jpg" mode="aspectFit" />
                    <p class="ec mt10">{{ item.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card" style="height: 340px">
            <div>
              <Calendar></Calendar>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import dayjs from "dayjs";
import { imgFlow } from "@/utils/data";
import { FlowOperationController } from "@/api/flowController";
import { CloudDisk } from "@/api/knowledge";
import Calendar from 'vue-calendar-component';
import { FlowEntryController } from '@/api/flowController';
import { Attendance } from '@/api/attendance'
import { SysFlowTaskType } from "@/staticDict/flowStaticDict";
import { mapMutations } from 'vuex';
import { Email } from '@/api/email'
export default {
  data() {
    return {
      timer: null,
      list: [],
      activeName: 'first',
      value: new Date(),
      dateTime: dayjs().format('YYYY-MM-DD'),
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '20%',
          left: 'right',
          orient: 'vertical'
        },
        series: [
          {
            name: '个人考勤',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 0, name: '未打卡' },
              { value: 0, name: '迟到' },
              { value: 0, name: '早退' },
              { value: 0, name: '请假' },
              { value: 0, name: '加班' },
              // {value: 0, name: '出差'},
              // {value: 0, name: '外出'}
            ],
            color: [
              "#53e69d",
              "#e72a17",
              "#8f82bc",
              "#f6b37f",
              "#2cabe3",
              // "#7bcef3",
              // "#a6937c",
            ]
          }
        ]
      },
      dataList: [],
      fileList: [],
      token: localStorage.getItem('token'),
      menuList: JSON.parse(localStorage.getItem('menuList')),
      SysFlowTaskType,
      count: 0
    }
  },
  components: {
    Calendar
  },
  created() {
    const arr = window.location.href.split('?')
    if(arr.length>1){
      const type = arr[1].split('=')[1]
      if(type === 'remindingMessage') {
        this.$router.replace({
          name:'formMessage',
          query:{
            type:'remindingMessage'
          }
        })
      } else {
        this.handleEmail()
      }
    }
    this.init()
    this.initEmail()
    this.getUpcomingWork()
    this.getCloudData()
  },
  methods: {
    ...mapMutations(['setCurrentMenuId']),
    initEmail(){
      Email.getCount(this).then(res => {
        this.count = res.data.notReadNum
      })
    },
    handleEmail(){
      this.setCurrentMenuId('1697215116639997952');
    },
    init() {
      const arr = this.menuList ? this.menuList.data.filter(item => item.onlineFlowEntryId) : []//
      FlowEntryController.getTreeList(this, {}).then(res => {
        let list = []
        for (let key in res.data) {
          list.push(...res.data[key])
        }
        // 处理菜单名称与借口名称不符
        const obj = {
          '费用报销单': '费用报销申请'
        }
        let count = 0
        arr.forEach(data => {
          list.forEach(item => {
            if (data.menuName === item.processDefinitionName || obj[data.menuName] === item.processDefinitionName) {
              data.processDefinitionKey = item.processDefinitionKey
              count++
              // 判断表名,寻找对应的图表
              data.img = imgFlow[item.processDefinitionKey]
            }
          })
        })
        this.list = arr.length > 7 ? arr.splice(0, 7) : arr
      })
      Attendance.getIndexPie(this).then(res => {
        this.option.series[0].data = res.data
        this.$nextTick(() => {
          let getChart = echarts.init(document.getElementById('echart-pie'))
          getChart.setOption(this.option)
        })
      })
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    /**
     *@desc 获取待办工作
     *@author Matthew
     *@date 2023/04/03 10:59:40
     */
    getUpcomingWork() {
      let pageParam = {
        pageNum: 1,
        pageSize: 10
      }
      FlowOperationController.listRuntimeTask(this, { pageParam }).then(res => {
        this.dataList = res.data.dataList
      })
    },
    /**
     *@desc 获取云盘资料
     *@author Matthew
     *@date 2023/04/03 10:59:48
     */
    getCloudData() {
      let params = {
        cloudDiskDtoFilter: {
          type: 'FILE'
        }
      }
      CloudDisk.getCloudDiskList(this, params).then(res => {
        if (res.data.dataList.length > 0) {
          res.data.dataList.forEach((item, index) => {
            if (!item.suffix) {
              res.data.dataList.splice(index, 1)
            }
          })
        }
        this.fileList = res.data.dataList
      })
    },
    /**
     *@desc 选中文件
     *@author Matthew
     *@date 2023/04/03 11:05:07
     */
    handleClickImg(item) {
      let that = this
      this.$confirm('请确认下载该文件!', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '返回',
        type: 'warning'
      }).then(() => {
        const url = item.downloadPath + `&Authorization=${this.token}&dataId=${item.id}`
        that.downloadFile2(url, item.name).then(res => {
          this.$message({
            type: 'success',
            message: '下载成功!'
          });
        }).catch(() => {
          this.$message.error('下载失败');
        })
      })
    },
    // create wang 2023/4/03
    onStartFlow(data) {
      let params = {
        processDefinitionKey: data.processDefinitionKey
      }
      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          localStorage.removeItem(data.processDefinitionKey + 'flag')
          localStorage.removeItem(data.processDefinitionKey)
          localStorage.removeItem(data.processDefinitionKey+'list')
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: data.processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              flowEntryName: data.menuName,
              operationList: (res.data.operationList || []).filter(item => item.type !== this.SysFlowTaskOperationType.CO_SIGN),
              variableList: res.data.variableList
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: this.processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => { });
        }
      }).catch(e => { });
    },
    // 待办
    onSubmit(row) {
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      }
      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              // 过滤掉加签操作，加签只有在已完成任务里可以操作
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList,
              serialNo: row.serialNo,
              data33: row.data33
            }
          });
        }
      }).catch(e => { });
    },
  }
}
</script>

<style lang="scss" scoped>
.email{
  position: relative;
.count{
  position: absolute;
  left: 57%;
  top: -5px;
}
}
.mt10 {
  margin-top: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}

.border {
  border: 1px solid #000;
}

.point {
  cursor: pointer;
}

.ec {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

p {
  margin: 0;
}

li {
  list-style: none;
  margin: 9px 0;
}

ul {
  padding-left: 0;
  margin: 0;
  overflow: hidden;

  li:first-child {
    margin-top: 0;
  }
}

h4 {
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 2px 0;
}

.work {
  padding: 10px;
  cursor: pointer;
}

.work:hover {
  background-color: #f0eded;
}

.auto {
  overflow: auto;
}

::v-deep .el-calendar .el-calendar__header {
  display: none !important;
}

::v-deep .el-calendar .el-calendar__body {
  padding: 0 !important;
}

::v-deep .el-calendar-table .el-calendar-day {
  width: 30px;
  height: 30px;
}

::v-deep .el-calendar-table thead th {
  padding: 0 !important;
}

.wh_container {
  max-width: 100%;
}

::v-deep.wh_content {
  justify-content: center;
}

::v-deep .wh_content_all {
  background: #fff !important;
}

::v-deep .wh_content_item {
  color: #000 !important;
}

::v-deep .wh_top_changge li {
  color: #000;
  height: 30px;
}

::v-deep .wh_jiantou1 {
  border-color: #000 !important;
}

::v-deep .wh_jiantou2 {
  border-color: #000 !important;
}

::v-deep .wh_content_item .wh_isToday {
  background: #4999fe !important;
  color: #ffffff;
}

::v-deep .wh_content_item .wh_chose_day {
  background: #ffffff;
}

::v-deep .wh_item_date:hover {
  background: none !important;
}

::v-deep .wh_isToday:hover {
  background: #4999fe !important;
}
</style>
